import { InlineRowFormComponentConfig } from '../inline-row-form';
import { CrudFormItem } from './crud-form-item.interface';

export interface CrudFormInlineRowFormItem extends CrudFormItem, InlineRowFormComponentConfig {
}
